var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DEFAULT_USER_SORT, PICKER_LIMIT } from "../utils/constants";
import { API_PATHS, usersId, usersIdResetPassword, usersIdOrganizationsCount, usersIdSourcesCount, usersUseridOrganizations, usersUseridOrganizationsOrgid, } from "../types/apiPaths";
var getHeaders = function () { return ({
    "Cache-Control": "no-cache, no-store, must-revalidate",
    Pragma: "no-cache",
    Expires: "0",
}); };
export var fetchUsers = function (kyInstance, filters, signal) { return __awaiter(void 0, void 0, void 0, function () {
    var search, organization, archived, offset, limit, _a, sortBy, params, queryString, response, data, error_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                search = filters.search, organization = filters.organization, archived = filters.archived, offset = filters.offset, limit = filters.limit, _a = filters.sortBy, sortBy = _a === void 0 ? DEFAULT_USER_SORT : _a;
                params = new URLSearchParams();
                if (search)
                    params.append("search", search);
                if (organization)
                    params.append("organization", organization);
                if (archived !== undefined)
                    params.append("archived", String(archived));
                if (offset !== undefined)
                    params.append("offset", String(offset));
                if (limit !== undefined)
                    params.append("limit", String(limit));
                params.append("sortBy", sortBy);
                queryString = params.toString() ? "?".concat(params.toString()) : "";
                return [4 /*yield*/, kyInstance.get("".concat(API_PATHS.USERS).concat(queryString), {
                        headers: getHeaders(),
                        signal: signal,
                    })];
            case 1:
                response = _b.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                data = (_b.sent());
                return [2 /*return*/, {
                        users: data.users,
                        totalRecords: data.totalRecords,
                    }];
            case 3:
                error_1 = _b.sent();
                console.error("Fetch error:", error_1);
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Users for a search-as-you-type picker: e-mail or name contains the term, the largest page the backend allows.
 *
 * @param kyInstance the okapi ky instance
 * @param search the typed term
 * @param signal aborts the request when the term changed
 * @returns the matching users (at most PICKER_LIMIT)
 */
export var fetchUserOptions = function (kyInstance, search, signal) {
    return fetchUsers(kyInstance, { search: search, limit: PICKER_LIMIT }, signal);
};
export var changeUserPassword = function (ky, userId, passwords) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, ky.post(API_PATHS.USERS_CHANGE_CURRENT_PASSWORD, {
                        json: passwords,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Failed to change password");
                }
                console.log("Password changed successfully");
                return [3 /*break*/, 3];
            case 2:
                error_2 = _a.sent();
                console.error("Failed to change password:", error_2);
                throw error_2;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var selectOrganization = function (ky, organizationId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, ky.post(API_PATHS.BR_USERS_SELECT_ORGANIZATION, {
                        json: { organizationId: organizationId },
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Failed to select organization");
                }
                console.log("Organization selected successfully");
                return [3 /*break*/, 3];
            case 2:
                error_3 = _a.sent();
                console.error("Failed to select organization:", error_3);
                throw error_3;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var fetchCurrentUser = function (ky) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, ky.get(API_PATHS.BR_USERS_SELF, {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, (_a.sent())];
            case 3:
                error_4 = _a.sent();
                console.error("Error fetching current user:", error_4);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
export var manageUserOrganization = function (ky, userUuid, orgUuid, action) { return __awaiter(void 0, void 0, void 0, function () {
    var endpoint, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                endpoint = "br-users/users/".concat(userUuid, "/organizations/").concat(orgUuid, "/").concat(action);
                return [4 /*yield*/, ky.post(endpoint, {
                        headers: getHeaders(),
                    })];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                error_5 = _a.sent();
                console.error("Error ".concat(action, " organization association for user ").concat(userUuid, ":"), error_5);
                throw error_5;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var updateUser = function (ky, userId, updates) { return __awaiter(void 0, void 0, void 0, function () {
    var error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, ky.put(usersId(userId), {
                        json: updates,
                        headers: getHeaders(),
                    })];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                error_6 = _a.sent();
                console.error("Error updating user with ID ".concat(userId, ":"), error_6);
                throw error_6;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var updateMyProfile = function (ky, updates) { return __awaiter(void 0, void 0, void 0, function () {
    var error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, ky.put(API_PATHS.USERS_MY_PROFILE, {
                        json: updates,
                        headers: getHeaders(),
                    })];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                error_7 = _a.sent();
                console.error("Error updating user profile:", error_7);
                throw error_7;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var fetchUserOrganizations = function (ky, userId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, ky
                        .get(usersUseridOrganizations(userId), {
                        headers: getHeaders(),
                    })
                        .json()];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.userOrganizations || []];
            case 2:
                error_8 = _a.sent();
                console.error("Error fetching organizations for user ".concat(userId, ":"), error_8);
                throw error_8;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var fetchMyOrganizationsCount = function (ky) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, ky
                        .get(API_PATHS.USERS_MY_ORGANIZATIONS_COUNT, {
                        headers: getHeaders(),
                    })
                        .json()];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.count];
            case 2:
                error_9 = _a.sent();
                console.error("Error fetching my organizations count:", error_9);
                throw error_9;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var fetchMySourcesCount = function (ky) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, ky
                        .get(API_PATHS.USERS_MY_SOURCES_COUNT, {
                        headers: getHeaders(),
                    })
                        .json()];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.count];
            case 2:
                error_10 = _a.sent();
                console.error("Error fetching my sources count:", error_10);
                throw error_10;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var fetchUserOrganizationsCount = function (ky, userId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, ky
                        .get(usersIdOrganizationsCount(userId), {
                        headers: getHeaders(),
                    })
                        .json()];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.count];
            case 2:
                error_11 = _a.sent();
                console.error("Error fetching organizations count for user ".concat(userId, ":"), error_11);
                throw error_11;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var fetchUserSourcesCount = function (ky, userId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_12;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, ky
                        .get(usersIdSourcesCount(userId), {
                        headers: getHeaders(),
                    })
                        .json()];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.count];
            case 2:
                error_12 = _a.sent();
                console.error("Error fetching sources count for user ".concat(userId, ":"), error_12);
                throw error_12;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var fetchUserById = function (ky, userId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, user, error_13;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, ky.get(usersId(userId), {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                user = _a.sent();
                return [2 /*return*/, user];
            case 3:
                error_13 = _a.sent();
                console.error("Error fetching user with ID ".concat(userId, ":"), error_13);
                throw error_13;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchMyProfile = function (ky) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_14;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, ky.get(API_PATHS.USERS_MY_PROFILE, {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_14 = _a.sent();
                console.error("Error fetching current user", error_14);
                throw error_14;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var createUser = function (ky, user) { return __awaiter(void 0, void 0, void 0, function () {
    var response, newUser, error_15;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, ky.post(API_PATHS.USERS, {
                        json: user,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                newUser = _a.sent();
                return [2 /*return*/, newUser];
            case 3:
                error_15 = _a.sent();
                console.error("Error creating user:", error_15);
                throw error_15;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var assignUserToOrganization = function (ky, userUuid, orgUuid, roles) { return __awaiter(void 0, void 0, void 0, function () {
    var error_16;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, ky.put(usersUseridOrganizationsOrgid(userUuid, orgUuid), {
                        json: { roles: roles },
                        headers: getHeaders(),
                    })];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                error_16 = _a.sent();
                console.error("Error assigning user to organization:", error_16);
                throw error_16;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var removeUserFromOrganization = function (ky, userUuid, orgUuid) { return __awaiter(void 0, void 0, void 0, function () {
    var error_17;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, ky.delete(usersUseridOrganizationsOrgid(userUuid, orgUuid), {
                        headers: getHeaders(),
                    })];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                error_17 = _a.sent();
                console.error("Error removing user from organization:", error_17);
                throw error_17;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var resetPasswordAdmin = function (ky, userUuid, newPassword, sendEmail) { return __awaiter(void 0, void 0, void 0, function () {
    var error_18;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, ky.post(usersIdResetPassword(userUuid), {
                        json: { newPassword: newPassword, sendEmail: sendEmail },
                        headers: getHeaders(),
                    })];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                error_18 = _a.sent();
                console.error("Error resetting password for user ".concat(userUuid, ":"), error_18);
                throw error_18;
            case 3: return [2 /*return*/];
        }
    });
}); };
